import React, { useEffect, useState } from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import moment from "moment";
import api from "../../../utils/api";
import close_modal from "./../../../assets/ic_close_wh.svg";
import Spinner from "../../../common/Spinner/Spinner";
import { toast } from "react-toastify";

export default function SMSTrailModal(props) 
{
    const [auditLog,setAuditLog] = useState([]);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if(props.isOpen)
        {
            if(props.nResourceInstanceId)
            {
                setLoading(true);
                let payload={nResourceInstanceId:props.nResourceInstanceId};
                api.getESPSMSLogByServiceId(payload)
                .then((d) => {
                    setAuditLog(d.data);
                    setLoading(false);
                }).catch((error) =>
                {
                    setLoading(false);
                    if(error.response.data.detail)
                    {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                    else if(error.response.data.message)
                    {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                    else
                    {
                        toast("Internal server error", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }                    
                });
            }            
        }        
      }, [props.isOpen]);

      const renderAuditTrail = () => {
        return Object.keys(auditLog).map((key,i) => {
          return(
            <div className={`${i%2==0?'notes-trail-box-even':'notes-trail-box-odd'}`} key={i}>
              <div className="flex justify-content-between">
                <small className="notes-trail-text">{auditLog[key].external_sp}</small>
                <small className="notes-trail-text">{moment(auditLog[key].date_created).format('lll')}</small>
              </div>
              <div className="conv-mt15">
                <div><small className="notes-trail-text">SMS</small></div>
                <div className="notes-trail-content-text conv-mt5" style={{whiteSpace: "pre-line"}}>
                  {auditLog[key].sms_content}
                </div>     
              </div>
            </div>
          )
        })
      }

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.toggleModal}
      ariaHideApp={false}
    >
      <ModalContent className="lpm-notes-trail-modal">
          <div className="modal-header">
          <span className="modal-title">SMS Trail</span>
            <img
                alt="close"
                id="Close"
                src={close_modal}
                className="close modal-close"
                onClick={props.toggleModal}
            />
          </div>
        
        <div
            className={`modal-body notes-trail-content custom-scrollbar ${isLoading && "set-opacity"}`}
        >
            {isLoading && <Spinner className="top"/>}
            <div className="conv-mt10">                
                {Object.keys(auditLog).length>0?renderAuditTrail():<div className="notes-trail-box-even">No SMS Sent</div>}
            </div>
        </div>
      </ModalContent>
    </Modal>
  );
}